import { useQuery } from "@tanstack/react-query";
import {BackendContextResponse} from "./types";
import {handleServerResponse} from "../api/error.helper";

async function getBackendContext(): Promise<BackendContextResponse> {
  const {
    account: { id: organizationId },
    user: { id: userId },
  } = VSS.getWebContext();

  const response = await fetch('/actionable-agile/api/app-context', {
    method: 'GET',
    headers: {
      'x-55d-org-id': organizationId,
      'x-55d-user-id': userId,
    },
  });

  const data = await handleServerResponse<BackendContextResponse>(response);
  return data;
}

const useBackendContext = () =>
  useQuery({
    queryKey: ['backendContext'],
    queryFn: getBackendContext,
    staleTime: Infinity,
    placeholderData: {
      buildKey: '',
      environment: '',
    }
  });

export default useBackendContext;
